"use client";

import { useRef, useState } from "react";
import { PARADE } from "./data";
import { c } from "./hooks";

// Two copies of the set scroll left-to-right forever (62 s loop); hover/focus
// pauses; any Mojumon opens the art viewer, which also pauses the track via the
// page-level `art-open` class.

export default function Parade({ onArtOpen }: { onArtOpen: (open: boolean) => void }) {
  const dialog = useRef<HTMLDialogElement>(null);
  const trigger = useRef<HTMLElement | null>(null);
  const [art, setArt] = useState<{ name: string; src: string; key: number }>({ ...PARADE[0], key: 0 });
  const open = (mon: (typeof PARADE)[number], el: HTMLElement) => {
    trigger.current = el;
    setArt((a) => ({ ...mon, key: a.key + 1 }));
    onArtOpen(true);
    dialog.current?.showModal();
  };
  const onClose = () => { onArtOpen(false); trigger.current?.focus(); trigger.current = null; };
  const set = (clone: boolean) => (
    <div className={c("parade-set")} aria-hidden={clone || undefined}>
      {PARADE.map((mon) => (
        <figure key={mon.name} className={c("parade-mon")} role={clone ? undefined : "button"} tabIndex={clone ? undefined : 0} aria-label={clone ? undefined : `View ${mon.name} art`}
          onClick={(e) => open(mon, e.currentTarget)} onKeyDown={clone ? undefined : (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(mon, e.currentTarget); } }}>
          <img src={mon.src} alt={clone ? "" : `16-bit ${mon.name} sprite`} />
          <figcaption>{mon.name}</figcaption>
        </figure>))}
    </div>
  );
  return (
    <section className={c("moju-parade")} aria-labelledby="paradeTitle">
      <div className={c("parade-copy")}>
        <p className={c("section-kicker", "pixel-font")}>The world is full of encounters</p>
        <h2 id="paradeTitle">Who Will You Catch Next?</h2>
        <p>These are only some of the Mojumon waiting across the Crimson world. Explore every route, discover new partners, and build a party that feels completely yours.</p>
        <span className={c("parade-chip")}>Click a Mojumon • View Full Art</span>
      </div>
      <div className={c("parade-viewport")} tabIndex={0} aria-label="A moving showcase of catchable Mojumon. Hover or focus to pause. Select a Mojumon to view its art.">
        <div className={c("parade-track")}>{set(false)}{set(true)}</div>
      </div>
      <dialog ref={dialog} className={c("modal", "art-modal")} aria-labelledby="artTitle" onClose={onClose} onClick={(e) => { if (e.target === e.currentTarget) dialog.current?.close(); }}>
        <div className={c("art-viewer")}>
          <button className={c("art-close")} type="button" aria-label="Close Mojumon art" onClick={() => dialog.current?.close()}>×</button>
          <div className={c("art-frame")}><img key={art.key} src={art.src} alt={`16-bit ${art.name} sprite`} /></div>
          <h3 id="artTitle">{art.name}</h3>
          <p>16-Bit Mojumon Art</p>
        </div>
      </dialog>
    </section>
  );
}
